import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import { loadStripe } from "@stripe/stripe-js";
import firebase from "firebase/app";
import "firebase/functions";
import { hideLoadingAction, showLoadingAction } from "../../reducks/loading/actions";
import { useDispatch } from "react-redux";
import { soldOpus } from "../../reducks/opuses/operations";
// import { buyerSave } from "../../reducks/users/operations";
// import { getUserId } from "../../reducks/users/selectors";

const useStyles = makeStyles({
  button: {
    backgroundColor: "#216174",
    color: "#FFF",
    fontSize: 12,
    height: 26,
    width: "auto",
    padding: "0px 30px",
  },
});

// const showPayment = async (price, name, boothId) => {
//   // セッション作成functionをインスタンス化
//   const createPaymentSession = firebase.functions().httpsCallable("createPaymentSession");

//   // 公開可能キーをもとに、stripeオブジェクトを作成
//   const stripePromise = loadStripe(
//     "pk_test_51IsKsuKSlIImOvRf2bQwEE4nGMO7MqEmLaVztpbH78eDwKTC84akt2XPCQO263BE9M5t6t75s6rQVEn6f2QKMPjr00rmRPN9xh"
//   );
//   const stripe = await stripePromise;

//   // セッション情報をもとに、支払いページに遷移
//   createPaymentSession({
//     price: price,
//     name: name,
//     boothId: boothId,
//   }).then((result) => {
//     stripe
//       .redirectToCheckout({
//         sessionId: result.data.id,
//       })
//       .then((result) => {
//         console.log(result);
//         console.log("支払い後の発火");
//       });
//   });
// };

const PurchaseButton = (props) => {
  const dispatch = useDispatch();
  // const selector = useSelector((state) => state);
  // const buyerId = getUserId(selector);
  const classes = useStyles();
  const price = props.price;
  const name = props.name;
  const boothId = props.boothId;
  const opusId = props.id;
  // const artistId = props.uid;
  // console.log("userIdは：" + artistId, "buyerIdは" + buyerId);

  const showPayment = async (price, name, boothId) => {
    // セッション作成functionをインスタンス化
    const createPaymentSession = firebase.functions().httpsCallable("createPaymentSession");

    // 公開可能キーをもとに、stripeオブジェクトを作成
    const stripePromise = loadStripe(
      "pk_test_51IsKsuKSlIImOvRf2bQwEE4nGMO7MqEmLaVztpbH78eDwKTC84akt2XPCQO263BE9M5t6t75s6rQVEn6f2QKMPjr00rmRPN9xh"
    );
    const stripe = await stripePromise;

    // セッション情報をもとに、支払いページに遷移
    createPaymentSession({
      price: price,
      name: name,
      boothId: boothId,
    }).then((result) => {
      dispatch(showLoadingAction("loading..."));
      stripe
        .redirectToCheckout({
          sessionId: result.data.id,
        })
        .then((result) => {
          console.log(result);
          dispatch(hideLoadingAction());
        });
      dispatch(hideLoadingAction());
      dispatch(soldOpus(opusId));
      // dispatch(buyerSave(artistId, buyerId));
    });
  };

  return (
    <Button className={classes.button} variant="contained" onClick={() => showPayment(price, name, boothId)}>
      {props.label}
    </Button>
  );
};
export default PurchaseButton;
